import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Input,
  Typography,
} from "@mui/material";
import CommonButton from "../Button";
import { LogoutIcon } from "../../../assets/icons/Icons";
import { useDispatch } from "react-redux";
import { notificationSuccess } from "../../../state/Action/NotificationAction";
import { changePassword } from "../../../Service/user.service";
import { useFormik } from "formik";
import { SampleProductStatusChange, SampleRequestStatusChange } from "../../../Service/sample.service";


const UpdateStatus = ({ handleClose, handelClick, modalOpen }) => {
  console.log("modalOpen", modalOpen);

  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const formik = useFormik({
    initialValues: {
      status: "",
      reason: "",
    },
    
    onSubmit: async (value) => {
      setLoading(true);
      const payload = {
        status: modalOpen?.status,
        reason: value.reason,
      };

      const res = modalOpen && modalOpen?.flag == 'product' ? await SampleProductStatusChange(modalOpen?.id,payload) : await SampleRequestStatusChange(modalOpen?.id, payload);

      if (res.status) {
        setLoading(false);
        dispatch(notificationSuccess({
          show: true,
          type: 'success',
          message: res.message || 'Status changed successfully.'
        }));
        handleClose();
      } else {
        setLoading(false);
        dispatch(notificationSuccess({
          show: true,
          type: 'error',
          message: res.message || 'Something went wrong.'
        }));
      }
    },
  });

  console.log("formik", formik);
  return (
    <>
      <>
        <DialogTitle>Update Status</DialogTitle>
        <DialogContent dividers sx={{ maxWidth: "500px", width: "100%" }}>
          <Typography
            className="myprofile_input_label"
            sx={{ paddingBottom: "2px" }}
          >
            Are You Sure you want to Update Status ?
          </Typography>
        </DialogContent>
        <DialogContent dividers sx={{ maxWidth: "500px", width: "100%" }}>
          <Grid item xs={12}>
            <Typography
              className="myprofile_input_label"
              sx={{ paddingBottom: "2px" }}
            >
              Reason
            </Typography>
            <Input
              labelinput={"Reason"}
              type="text"
              name="reason"
              {...formik.getFieldProps("reason")}
              error={
                formik.touched.reason &&
                Boolean(formik.errors.reason)
              }
              helperText={
                formik.touched.reason && formik.errors.reason
              }
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <CommonButton onClick={handleClose} buttonName="No" />
          <CommonButton onClick={formik.handleSubmit} buttonName="Yes" />
        </DialogActions>
      </>
    </>
  );
};

export default UpdateStatus;
